export interface AnModalBreakpoint {
  closeIconMargin: {
    top: string;
    right: string;
  },
  fullScreen: boolean;
  borderRadius: string;
  boxShadow: string;
}
export interface AnModalSetting {
  sm?: AnModalBreakpoint;
  md?: AnModalBreakpoint;
  lg?: AnModalBreakpoint;
  xl?: AnModalBreakpoint;
  scrolling?: boolean;
  closing?: {
    esc: boolean;
    backdrop: boolean;
  }
  backdropColor?: string;
}

export enum BreakpointsEnum {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}